import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Endpoints } from "src/app/shared/config/endpoints";
import { OrgModel, UserModel } from "src/app/store/storeModels/user.model";
import { GeneralService } from "../general.service";

@Injectable({
  providedIn: "root",
})
export class GroupService {
  private signupApi = this.endpoint.signUpEndpoint;
  private peopleSvc = this.endpoint.peopleEndpoint;
  private user: UserModel;
  private org: OrgModel;
  private groupID = "25";
  constructor(
    private endpoint: Endpoints,
    private http: HttpClient,
    private gs: GeneralService
  ) {
    this.user = this.gs.user;
    this.org = this.gs.org;
  }

  createGroup(payload: { name: string; members: any[] }) {
    payload.members.filter((m) => {
      return (m["agentID"] = m.userID);
    });
    const body = {
      grps: {
        name: payload.name,
        noOfMembers: payload.members.length,
        noOfTickets: 0,
        totalTicketsResolved: 0,
        orgID: this.org.id.toString(),
      },
      members: [...payload.members],
      noOfMembers: payload.members.length,
    };
    return this.http.post(this.peopleSvc + "/addGroup", body);
  }

  updateGroup(payload: any) {
    return this.http.post(this.peopleSvc + "/update/group", payload);
  }

  fetchGroup() {
    return this.http.get(
      this.peopleSvc + `/groups/organization/${this.org.id}/`
    );
  }

  getOrganizationGroups() {
    return this.http.get(
      this.peopleSvc + `/groups/organization/${this.org.id}/`
    );
  }

  fetchOneGroup(id) {
    return this.http.get(this.peopleSvc + `/getGroup/${id}`);
  }

  editGroup(payload) {
    return this.http.post(this.peopleSvc + "/editGroup", payload);
  }

  // editGroupName(payload, groupID) {
  //   const url = `${this.peopleSvc}/editGroupName/${groupID}/`;
  //   return this.http.put(url, payload);
  // }

  addGroupMember(payload) {
    const body = {
      groupID: payload.groupID,
      orgID: this.org.id,
      agents: payload.agents,
    };
    return this.http.post(this.peopleSvc + "/GroupMembers/add", body);
  }

  removeGroupMember(groupID: number, id: number) {
    const url = `${this.peopleSvc}/delete/member/${id}`;
    return this.http.delete(url);
  }

  // Group Custom Filter
  getGroupCustomFilters() {
    const url = `${this.peopleSvc}/${this.gs.orgID}/${this.gs.user.id}/getGroupCustomFilters`;
    return this.http.get(url);
  }

  fetchAgentGroups(agentID) {
    return this.http.get(
      `${this.peopleSvc}/getMemberGroups/${agentID}/${this.gs.org.id}`
    );
  }

  newGroupCustomFilter(payload) {
    payload = { ...payload, orgID: this.gs.orgID, userID: this.gs.user.id };
    return this.http.post(this.peopleSvc + `/newGroupCustomFilter`, payload);
  }

  updateGroupCustomFilter(payload) {
    payload = { ...payload, orgID: this.gs.orgID, userID: this.gs.user.id };
    return this.http.post(this.peopleSvc + `/updateGroupCustomFilter`, payload);
  }

  getFilteredGroups(id) {
    const url = `${this.peopleSvc}/${id}/getFilteredGroups`;
    return this.http.get(url);
  }

  filterGroupsByNumberOfMembers(from, to) {
    return this.http.get(`${this.peopleSvc}/${from}/${to}/${this.org.id}/getFilteredGroupsByNoOfMembers`);
  }

  filterGroupsByNumberOfTickets(from, to) {
    return this.http.get(`${this.peopleSvc}/${from}/${to}/${this.org.id}/getFilteredGroupsByNoOfTickets`);
  }

  filterGroupsByNumberOfResolvedTickets(from, to) {
    return this.http.get(`${this.peopleSvc}/${from}/${to}/${this.org.id}/getFilteredGroupsByNoOfTicketsResolved`);
  }

  deleteGroupCustomFilter(id) {
    return this.http.delete(this.peopleSvc + `/${id}/deleteGroupCustomFilter`);
  }

  // Agent Custom Filter
  getAgentCustomFilters() {
    return this.http.get(
      this.signupApi +
      `/${this.gs.orgID}/${this.gs.user.id}/getAgentCustomFilters`
    );
  }

  getFilteredAgents(ticketValue, resolvedValue) {
    return this.http.get(
      this.signupApi +
      `/${ticketValue}/${resolvedValue}/${this.gs.orgID}/getFilteredAgentsByNumberOfTicketsAndTicketsResolved`
    );
  }

  filterAgentsByNumberOfTickets(from, to) {
    return this.http.get(`${this.signupApi}/${from}/${to}/${this.org.id}/getFilteredAgentsByNumberOfTickets`);
  }

  filterAgentsByNumberOfResolvedTickets(from, to) {
    return this.http.get(`${this.signupApi}/${from}/${to}/${this.org.id}/getFilteredAgentsByNumberOfTicketsResolved`);
  }

  newAgentCustomFilter(payload) {
    payload = {
      fromNoOfTickets: payload.fromNoOfTickets,
      fromNoOfTicketsResolved: payload.fromNoOfTicketsResolved,
      name: payload.filterName,
      noOfTickets: payload.noOfTickets,
      noOfTicketsResolved: payload.noOfTicketsResolved,
      orgID: this.gs.orgID,
      userID: this.gs.user.id
    };
    return this.http.post(this.signupApi + `/newAgentCustomFilter`, payload);
  }

  updateAgentCustomFilter(payload) {
    payload = {
      fromNoOfTickets: payload.fromNoOfTickets,
      fromNoOfTicketsResolved: payload.fromNoOfTicketsResolved,
      id: payload.id,
      name: payload.filterName,
      noOfTickets: payload.noOfTickets,
      noOfTicketsResolved: payload.noOfTicketsResolved,
      orgID: this.gs.orgID,
      userID: this.gs.user.id
    };
    return this.http.post(this.signupApi + `/updateAgentCustomFilter`, payload);
  }

  deleteAgentCustomFilter(id) {
    return this.http.delete(this.signupApi + `/${id}/deleteAgentCustomFilter`);
  }
}
